import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { MockLocationProvider } from "./contexts/MockLocationContext";
import { LocationTrackingProvider } from "./contexts/LocationTrackingContext";

export function App() {
  return (
    <MockLocationProvider>
      <LocationTrackingProvider>
        <RouterProvider router={router} />
      </LocationTrackingProvider>
    </MockLocationProvider>
  );
}
